import { render, staticRenderFns } from "./messageDetail.vue?vue&type=template&id=3f701f66&scoped=true&"
import script from "./messageDetail.vue?vue&type=script&lang=js&"
export * from "./messageDetail.vue?vue&type=script&lang=js&"
import style0 from "./messageDetail.vue?vue&type=style&index=0&id=3f701f66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f701f66",
  null
  
)

export default component.exports